module.exports = __webpack_public_path__ + "static/img/7.c3e5af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colectivo-de-vida/7.png
// module id = lXpL
// module chunks = 0